import { RetrieveAuthorizationVerbiageResponseV1 } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsSelectPaymentMethodAuthorizationVerbiageActions =
  createActionGroup({
    source: 'Hosted Payments Select Payment Method Authorization Verbiage',
    events: {
      'Surcharge Authorization Verbiage Retrieved': props<{
        payload: RetrieveAuthorizationVerbiageResponseV1;
      }>(),
    },
  });
